/** points — EN source. */
export const points = {
  points_launcher_tab_open_button: "Points & Rewards",

  // My Points (home)
  points_home_balance_label: "Points",
  points_home_stat_this_week: "This Week",
  points_home_stat_this_month: "This Month",
  points_home_stat_all_time: "All Time",
  points_home_stat_redeemed: "Redeemed",
  points_home_recent_activity_title: "Recent Activity",
  points_home_recent_activity_empty: "No activity yet",
  points_home_see_all_button: "See All →",

  // Navigation rows
  points_nav_rewards: "Rewards Store",
  points_nav_achievements: "Achievements",
  points_nav_history: "Points History",
  points_nav_invite: "Invite & Earn",

  // Relative time
  points_time_just_now: "just now",
  points_time_minutes_ago: "{count}m ago",
  points_time_hours_ago: "{count}h ago",
  points_time_days_ago: "{count}d ago",

  // Ledger source labels
  points_source_profile_completion: "Profile completed",
  points_source_daily_login: "Daily check-in",
  points_source_referral: "Referral bonus",
  points_source_card_exchange: "Card exchanged",
  points_source_experience_confirmation: "Meetup confirmed",
  points_source_achievement: "Achievement unlocked",
  points_source_founding_member: "Founding member",
  points_source_event_check_in: "Event check-in",
  points_source_tap_connect: "Tap to connect",
  points_source_qr_swap: "QR swap",
  points_source_social_share: "Social share",
  points_source_invite_new_user: "Friend joined",
  points_source_mini_game: "Mini-game",
  points_source_photo_challenge: "Photo challenge",
  points_source_leaderboard: "Leaderboard",
  points_source_reward_redemption: "Reward redeemed",
  points_source_admin_adjustment: "Adjustment",

  // Rewards Store
  points_rewards_category_badges: "Badges",
  points_rewards_category_perks: "Perks",
  points_rewards_category_merch: "Merch",
  points_rewards_category_events: "Events",
  points_rewards_category_partner: "Partner Perks",
  points_rewards_coming_soon_tag: "Coming Soon",
  points_rewards_filter_all: "All",
  points_rewards_empty: "No rewards in this category yet",
  points_rewards_state_coming_soon: "🔒 Coming Soon",
  points_rewards_state_owned: "✅ Owned",
  points_rewards_redeem_button: "Redeem",
  points_rewards_need_more: "Need {count} more",
  points_rewards_redeem_dialog_title: "Redeem {name}?",
  points_rewards_redeem_dialog_description:
    "This will deduct {cost} Points and add it to your account. Badges are permanent.",
  points_rewards_redeem_cancel: "Cancel",
  points_rewards_redeeming: "Redeeming…",
  points_rewards_redeem_confirm: "Confirm · {cost}",

  // Rewards Store — badges help
  points_rewards_badges_help_aria: "How to get badges",
  points_rewards_badges_help_title: "How to get badges",
  points_rewards_badges_help_intro:
    "Badges are permanent and show on your Linq Card. Redeem them with Points. Earn Points by checking in daily, completing your profile, making connections, attending events and inviting friends.",
  points_rewards_badges_help_how: "Redeem for {cost} Points",
  points_rewards_badges_help_coming_soon: "Coming soon",
  points_rewards_badges_help_granted:
    "Some badges, like Founding Member, are granted automatically and can't be bought.",
  points_rewards_badges_help_close: "Got it",

  // Achievements
  points_achievements_unlocked_count: "{unlocked} / {total} Unlocked",
  points_achievements_milestones_title: "Milestones",
  points_achievements_badges_title: "Your Badges",
  points_achievements_badges_get: "Get",
  points_achievements_badges_empty:
    "No badges yet — redeem one in the Rewards Store.",
  points_achievements_first_connection: "Make your first connection",
  points_achievements_reach_connections: "Reach {count} connections",
  points_achievements_attend_events: "Attend {count} events",
  points_achievements_unlocks_with_events: "Unlocks with Events",

  // Points History
  points_history_filter_all: "All",
  points_history_filter_earned: "Earned",
  points_history_filter_spent: "Spent",
  points_history_day_today: "Today",
  points_history_day_yesterday: "Yesterday",
  points_history_empty: "Nothing here yet.",
  points_history_redeemed_badge: "Redeemed",
  points_history_loading_more: "Loading…",
  points_history_load_more: "Load more",

  // Invite & Earn
  points_invite_hero_title: "Invite friends, earn Points",
  points_invite_hero_description:
    "Get +{count} Points each time a friend joins through your link and finishes setting up.",
  points_invite_link_label: "Your invite link",
  points_invite_copied: "Copied!",
  points_invite_copy: "Copy",
  points_invite_share_button: "Share invite link",
  points_invite_share_title: "Join me on Linqx",
  points_invite_how_it_works_title: "How it works",
  points_invite_step_share: "Share your link",
  points_invite_step_friend_opens: "Friend opens it & signs up",
  points_invite_step_onboarding: "They finish onboarding",
  points_invite_step_reward: "You get +{count} Points",
  points_invite_footer_note: "Credits show in Points History",
};
